import { IQuest, IQuestStep } from 'components/quests/loyalty-quest/types';

export enum UserJourneyFields {
  DateOfBirth = 'dob',
  ZipCode = 'zipCode',
  Email = 'email',
  PushNotification = 'pushNotification',
  PhoneNumber = 'phoneNumber',
}

export enum UserJourneySections {
  ProfileSetting,
  Communications,
}

export const USER_JOURNEY_FIELDS_BY_SECTION: Record<UserJourneySections, UserJourneyFields[]> = {
  [UserJourneySections.ProfileSetting]: [UserJourneyFields.DateOfBirth, UserJourneyFields.ZipCode],
  [UserJourneySections.Communications]: [
    UserJourneyFields.Email,
    UserJourneyFields.PushNotification,
    UserJourneyFields.PhoneNumber,
  ],
};

const getUserJourneyStepByField = (challenge: IQuest, field: UserJourneyFields) => {
  return challenge.steps?.find(step => step.field === field);
};

export const getUserJourneyStepsForSection = (
  challenge: IQuest,
  section: UserJourneySections
): { [k in UserJourneyFields]?: IQuestStep } => {
  return Object.fromEntries(
    USER_JOURNEY_FIELDS_BY_SECTION[section].map(field => [
      field,
      getUserJourneyStepByField(challenge, field),
    ])
  );
};
